import(/* webpackMode: "eager" */ "/var/www/kasturifoodproducts-app/src/app/not-found.tsx");
